<template>
  <div class="home">
    <div class="d-flex justify-content-center align-items-center h-100">
      <p class="fs-1">歡迎到 Future Mall 後台</p>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>
  .home{
    height: calc(100vh - 90px);
  }
</style>
